/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import { handleApiError } from "@utils/errorHandler";
import EncloseTable from "@shared/baseUI/EnhancedTable/EncloseTable";
import { loadAllSolutions } from "./SolutionsList.actionCreators";
import {
  setAllSolutionsLoadingState,
  hideSolutionsAllocation,
  showSolutionsAllocation,
} from "./SolutionsList.slice";
import { SolutionsListContainer } from "./SolutionsList.styled";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import TextNode from "./components/TextNode";
import Comment from "./components/Comment";
import SolutionId from "./components/SolutionId";
import SolutionsActions from "./components/SolutionsActions";
import Price from "./components/Price";
import SolutionsAllocationSettings from "./components/SolutionsAllocationSettings";
import AllocationWarning from "./components/AllocationWarning";
import AddEditSolution from "../AddEditSolution";
import { columnHeader, isEmpty } from "@utils/utils";
import { solutionStatus } from "@utils/filterOptions";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

import {
  TABLE_SOLUTIONS_LIST,
  FILTER_TYPE_MULTI_SELECT_DROPDOWN,
  PAGE_SIZE,
  SOLUTIONS_LIST_ENDPOINT,
  FILTER_TYPE_BUTTON,
} from "@utils/constants";

import "./SolutionsList.scss";

/**
 * Solutions List,
 * Path - /request/view/{id}
 * @see See [Solutions Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/1848147989/Solutions+section)
 * @component
 */
const PrepareDataTable = (props) => {
  const {
    t,
    columnList,
    enquiryId,
    siteId,
    centreId,
    enquiryStep,
    setEnquiryData,
    displayCreateButton,
    updateRequestRefeshStatus,
    enquiryService,
    enquirySubCategoryName,
    enquirySubCategoryId,
    countryId,
  } = props;
  const [isAllocationWarning, setAllocationWarning] = useState(false);
  const [isAddSolutionPopupVisible, setAddSolutionPopupVisibility] =
    useState(false);

  const generalParams = useGetGeneralParameters();

  const isAnswerByTechTeam = useSelector(
    (state) => state.solutionsList.isAnswerByTechTeam
  );
  const [data, setData] = useState([]);
  const [activeStatus, setActiveStatus] = useState(1);
  const [isRefreshDataAgain, setRefreshState] = useState(false);
  const [skipPageReset, setSkipPageReset] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [currentPageToFirst, setCurrentPageToFirst] = useState(false);
  const [additionalFilters, setAdditionalFilters] = useState([]);
  const [extraData, setExtraData] = useState({
    enquiryStepStatus: enquiryStep,
    solutionValidated: false,
  });

  const dataURL = SOLUTIONS_LIST_ENDPOINT;
  const dispatch = useDispatch();
  const isSiteListLoading = useSelector(
    (state) => state.solutionsList.isLoading
  );

  useEffect(() => {
    setLoading(isSiteListLoading);
  }, [isSiteListLoading]);

  const stageLabel = {
    4: "SOLUTION_STATUS_SELECTED",
    5: "SOLUTION_STATUS_TRANSPORT_QUOTATION",
    6: "SOLUTION_STATUS_QUOTED",
    7: "SOLUTION_STATUS_VALIDATED",
    8: "SOLUTION_STATUS_VALIDATED_KO",
    9: "SOLUTION_STATUS_VALIDATED_OUT_KO",
  };

  const typeColor = {
    4: "#FF981E",
    5: "#00AEEA",
    6: "#3EBBB9",
    7: "#008395",
    8: "#32A728",
    9: "#32A728",
  };

  const refreshData = (data) => {
    setRefreshState(data);
  };

  let columns = [
    {
      Header: t("ID"),
      title: "ID",
      accessor: "solutionId",
      Cell: ({ cell: { value } }) => (
        <SolutionId
          data={value}
          enquiryService={enquiryService}
          enquirySubCategoryName={enquirySubCategoryName}
          enquirySubCategoryId={enquirySubCategoryId}
          generalParams={generalParams}
          onRefreshData={refreshData}
          enquiryId={enquiryId}
          countryId={countryId}
        />
      ),
      disableFilters: true,
    },
    {
      Header: t("TYPE_SOLUTION"),
      title: "TYPE_SOLUTION",
      accessor: "solutionTypeId",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: t("CENTRE"),
      title: "CENTRE",
      accessor: "centreName",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
    },
    {
      Header: t("SITE_COMPANY"),
      title: "SITE_COMPANY",
      accessor: "siteCompany",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
    },
    {
      Header: t("SUPPLIER"),
      title: "SUPPLIER",
      accessor: "supplierName",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
    },
    {
      Header: t("PRODUCT"),
      title: "PRODUCT",
      accessor: "productName",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
    },
    {
      Header: t("TRUCK"),
      title: "TRUCK",
      accessor: "haulierName",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
    },
    {
      Header: t("PRICE"),
      title: "PRICE",
      accessor: "price",
      Cell: ({ cell: { value, column } }) => <Price solutionData={value} />,
      disableFilters: true,
    },
    {
      Header: " ",
      title: "COMMENTS",
      accessor: "comment",
      Cell: ({ cell: { value } }) => <Comment comment={value} />,
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: t("STAGE"),
      title: "STAGE",
      accessor: "stage",
      Cell: ({ cell: { value, column } }) => (
        <DivBackgroundOpacity opacity={value.isActive === 1 ? 1 : "0.2"}>
          <ColumnButton
            height="30px"
            border={typeColor[value.id]}
            background={typeColor[value.id]}
            padding="2px 4px 2px 4px"
          >
            <span>{t(stageLabel[value.id])}</span>
          </ColumnButton>
        </DivBackgroundOpacity>
      ),
    },
    {
      Header: t("REQUEST_MATCHINGS_LIST_ALLOCATION"),
      title: "REQUEST_MATCHINGS_LIST_ALLOCATION",
      accessor: "allocation",
      Cell: ({ cell: { value, column } }) => (
        <TextNode text={value} column={column} />
      ),
      disableFilters: true,
    },
    {
      Header: t("ACTION"),
      title: "ACTION",
      accessor: "action",
      Cell: ({ cell: { value, column } }) => (
        <SolutionsActions
          data={value}
          column={column}
          enquiryService={enquiryService}
          enquirySubCategoryName={enquirySubCategoryName}
          enquirySubCategoryId={enquirySubCategoryId}
          onRefreshData={refreshData}
          enquiryId={enquiryId}
          countryId={countryId}
        />
      ),
      disableFilters: true,
    },
  ];

  useEffect(() => {
    // everyTime we apply an custom filter we reset the page to 1
    setCurrentPageToFirst(true);
    if (!isEmpty(requestData) && requestData.currentPage === 1) {
      fetchRecords({
        pageSize: requestData.pageSize,
        pageStart: requestData.pageStart,
        globalFilter: requestData.globalFilter,
        sort: requestData.sort,
        currentPage: requestData.currentPage,
        appliedFilters: additionalFilters,
      });
    }
  }, [activeStatus, additionalFilters]);

  const solutionsListByIds = useSelector((state) => state.solutionsList.byId);
  const solutionsListAllIds = useSelector(
    (state) => state.solutionsList.allIds
  );
  const filteredRecords = useSelector(
    (state) => state.solutionsList.filteredRecords
  );

  const updateEnquiryStepFrance = () => {
    const jsonData = {
      previousStepId: enquiryStep,
      newStepId: 5,
    };
    // setIsSyncingRunning(true);
    axios
      .post(`/enquiries/${enquiryId}/transitionStep`, jsonData)
      .then((response) => {
        setEnquiryData(response?.data[0]);
      })
      .catch((error) => handleApiError(error));
  };

  /**
   * Method to fetch set of records based on the filters applied.
   * @param {pageSize} pageSize
   * @param {pageStart} pageStart
   * @param {globalFilter} globalFilter
   * @param {sort} sort
   * @param {appliedFilters} appliedFilters
   */
  const fetchRecords = ({
    pageSize,
    pageStart,
    globalFilter,
    sort,
    appliedFilters,
    currentPage,
  }) => {
    // save request data,
    setRequestData({
      pageSize,
      pageStart,
      globalFilter,
      sort,
      appliedFilters,
      currentPage,
    });

    let solutionStatusSelected = [];

    if (appliedFilters !== undefined) {
      const solutionStatusFilter = appliedFilters.filter(
        (filterItem) => filterItem.column === "solutionStatus"
      );
      solutionStatusSelected = solutionStatusFilter?.map((item) => item.value);
    }
    // Set the loading state
    setLoading(true);

    dispatch(setAllSolutionsLoadingState());
    dispatch(
      loadAllSolutions({
        dataURL,
        siteId: siteId ?? "",
        requestId: enquiryId ?? "",
        centreId: centreId ?? "",
        pageSize,
        currentPage,
        sort,
        search: globalFilter,
        statusFilter: activeStatus,
        stageOptions: solutionStatusSelected ?? "",
      })
    );
  };

  useEffect(() => {
    if (solutionsListAllIds.length > 0) {
      const responseData = solutionsListAllIds.map((id) => {
        const tempData = { ...solutionsListByIds[id] };
        const selectedTransportPrice =
          tempData.solutionTransportPrices?.find(
            (priceItem) => priceItem.selectedPrice === true
          ) ?? null;
        tempData.status = tempData.priceType;
        tempData.solutionId = {
          id: tempData.id,
          isActive: tempData.isActive,
          statusId: tempData.solutionStatus?.id,
          acceptances: tempData.acceptances,
          centre: tempData.centre,
        };
        tempData.platform = tempData?.centre?.isPlatform === true ? "1" : "0";
        tempData.supplierName = {
          name: tempData.centre?.supplierName
            ? tempData.centre.supplierName
            : tempData.haulier?.supplierName
            ? tempData.haulier.supplierName
            : tempData.linkedSolution?.suppilerName
            ? tempData.linkedSolution?.suppilerName
            : "",
          id: tempData.centre?.supplierId
            ? tempData.centre.supplierId
            : tempData.haulier?.supplierId
            ? tempData.haulier.supplierId
            : tempData.linkedSolution?.supplierId
            ? tempData.linkedSolution?.supplierId
            : "",
        };
        tempData.centreName = {
          name: tempData.centre?.companyName
            ? tempData.centre.companyName
            : tempData.haulier?.companyName
            ? tempData.haulier.companyName
            : tempData.linkedSolution?.companyName
            ? tempData.linkedSolution.companyName
            : "",
          id: tempData.centre?.companyId
            ? tempData.centre.companyId
            : tempData.haulier?.companyId
            ? tempData.haulier.companyId
            : tempData.linkedSolution?.companyId
            ? tempData.linkedSolution.companyId
            : "",
          isActive: tempData.isActive,
          supplierName: tempData.centre?.supplierName,
          priceType: parseInt(tempData.priceType, 10),
        };
        tempData.productName = {
          productName: tempData.centreProduct?.product?.name ?? "",
          isActive: tempData.isActive,
        };
        tempData.jobsiteName = {
          name: tempData.site?.name ?? "",
          id: tempData.site?.id,
        };
        tempData.companyName = {
          name: tempData.site?.companyName ?? "",
          id: tempData.site?.companyId,
        };
        tempData.siteCompany = {
          siteName: tempData.site?.name ?? "",
          siteId: tempData.site?.id,
          companyName: tempData.site?.companyName ?? "",
          companyId: tempData.site?.companyId,
          isActive: tempData.isActive,
        };
        tempData.haulierName = selectedTransportPrice?.transportType
          ? selectedTransportPrice?.transportType.name
          : "";

        tempData.stage = {
          id: tempData.solutionStatus.id,
          name: tempData.solutionStatus.name,
          isActive: tempData.isActive,
        };
        if (tempData.solutionStatus.id === 7)
          setExtraData({ ...extraData, solutionValidated: true });
        tempData.comment = {
          internalComment: tempData.internalComment,
          quoteComment: tempData.quoteComment,
          isActive: tempData.isActive,
        };
        tempData.treatmentPrice = {
          unit: "",
          price: "",
          currency: "",
          position: 1,
        };
        if (
          tempData?.solutionTreatmentPrices[0]?.isActive === 1 &&
          [1, 4].includes(tempData.priceType)
        ) {
          tempData.treatmentPrice = {
            unit:
              tempData.solutionTreatmentPrices[0]?.isActive === 1 &&
              tempData.solutionTreatmentPrices[0]?.unit
                ? t(tempData.solutionTreatmentPrices[0].unit)
                : "",
            price:
              tempData.solutionTreatmentPrices[0]?.isActive === 1 &&
              tempData.solutionTreatmentPrices[0]?.price,
            currency:
              tempData.solutionTreatmentPrices[0]?.isActive === 1 &&
              tempData.solutionTreatmentPrices[0]?.currency.id,
            position: tempData.solutionTreatmentPrices[0]?.currency.position,
          };
        }

        tempData.transportPrice = {
          unit: selectedTransportPrice?.unit
            ? t(selectedTransportPrice?.unit)
            : "",
          price: selectedTransportPrice?.price ?? "",
          currency: selectedTransportPrice?.currency?.id ?? "",
          position: selectedTransportPrice?.currency?.position ?? 1,
        };

        tempData.tgap = {
          unit: tempData.solutionTreatmentPrices[0]?.unit
            ? t(tempData.solutionTreatmentPrices[0].unit)
            : "",
          price: tempData.solutionTreatmentPrices[0]?.tgap,
          currency: tempData.solutionTreatmentPrices[0]?.currency.id,
          position: tempData.solutionTreatmentPrices[0]?.currency.position ?? 1,
        };
        tempData.solutionTypeId = tempData.priceType;
        tempData.action = {
          isActive: tempData?.isActive ?? 0,
          status: parseInt(tempData.solutionStatus.id, 10),
          id: tempData.id,
          priceType: tempData.priceType,
          solutionTypeId: tempData.priceType,
          selectedPrice: selectedTransportPrice?.selectedPrice,
          platformCountry: tempData.site.platformCountry,
          siteId: tempData.site?.id,
          requestId: tempData?.requestId,
          productId: tempData?.centreProduct?.product?.id,
          solutionTransportPrices: tempData?.solutionTransportPrices,
        };
        tempData.price = {
          solutionStatus: tempData.solutionStatus.id,
          priceType: tempData.priceType,
          solutionTreatmentPrices: tempData.solutionTreatmentPrices,
          solutionTransportPrices: tempData.solutionTransportPrices,
          isActive: tempData.isActive,
        };

        tempData.allocation = {
          allocation: tempData.allocation,
          isActive: tempData.isActive,
        };
        return tempData;
      });
      setData([...responseData]);
      setPageCount(filteredRecords);
      setLoading(false);
    } else {
      setData([]);
      setPageCount(0);
      setLoading(false);
    }
  }, [t, solutionsListAllIds, solutionsListByIds, filteredRecords]);

  columns = columnHeader(columns, columnList);

  const closeAllocationSettings = () => {
    dispatch(hideSolutionsAllocation());
    window.location.reload();
  };

  const onShowAllocationWarning = () => {
    dispatch(hideSolutionsAllocation());
    setAllocationWarning(true);
  };

  const handleYes = () => {
    setAllocationWarning(false);
    dispatch(hideSolutionsAllocation());
  };

  const handleNo = () => {
    setAllocationWarning(false);
    dispatch(showSolutionsAllocation());
  };

  const createSolution = () => {
    setAddSolutionPopupVisibility(true);
  };

  const closeSolutionCreationPopup = () => {
    setAddSolutionPopupVisibility(false);
    setRefreshState(true);
  };

  const isSolutionCreationEnabled = (state) => {
    const rejectedStatuses = [
      "PENDING",
      "REJECTED",
      "DELETED",
      "TECHNICAL_TEAM_CANCELED",
    ];
    return !rejectedStatuses.includes(state);
  };

  useEffect(() => {
    if (isRefreshDataAgain) {
      setRefreshState(false);
    }
  }, [isRefreshDataAgain]);

  const changeStatus = (label) => {
    let statusNew = activeStatus === 1 ? 2 : 1;
    setActiveStatus(statusNew);
  };

  const onSolutionCreation = () => {
    if (filteredRecords === 0 && parseInt(enquiryStep, 10) === 1) {
      updateRequestRefeshStatus();
    }
  };

  return (
    <SolutionsListContainer className="solutions-list">
      <EncloseTable
        type={TABLE_SOLUTIONS_LIST}
        columns={columns}
        data={data}
        setData={setData}
        createNewAction={displayCreateButton ? createSolution : null}
        customAction={updateEnquiryStepFrance}
        initialPageSize={PAGE_SIZE}
        isRefreshDataAgain={isRefreshDataAgain}
        setSkipPageReset={setSkipPageReset}
        skipPageReset={skipPageReset}
        pageCount={pageCount}
        setPageCount={setPageCount}
        fetchRecords={fetchRecords}
        currentPageToFirst={currentPageToFirst}
        setCurrentPageToFirst={setCurrentPageToFirst}
        loading={loading}
        setAdditionalFilters={setAdditionalFilters}
        additionalFilters={additionalFilters}
        defaultSortOptions={[{ id: "id", desc: true, dir: "desc" }]}
        extraData={extraData}
        extraFilters={[
          {
            type: FILTER_TYPE_BUTTON,
            label: "SOLUTIONS_FILTER_ACTIVE_ONLY",
            name: "admins",
            labelClass: "company-list__admins-list-label",
            containerClass: "company-list__admins-list-dropdown-container",
            imageEnableIcon: enableIcon,
            imageDisableIcon: disableIcon,
            status: activeStatus,
            changeStatus: { changeStatus },
          },
          {
            type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
            label: t("SOLUTIONS_FILTER_STATUS"),
            placeholder: t("SEARCH"),
            name: "solutionStatus",
            labelClass: "company-list__admins-list-label",
            containerClass: "company-list__admins-list-dropdown-container",
            defaultOption: "Nothing Selected",
            options: solutionStatus(t),
          },
        ]}
      />

      {isAnswerByTechTeam && (
        <SolutionsAllocationSettings
          onClose={closeAllocationSettings}
          onShowAllocationWarning={onShowAllocationWarning}
          enquiryId={enquiryId}
          siteId={siteId}
        />
      )}
      {isAllocationWarning && (
        <AllocationWarning onYes={handleYes} onNo={handleNo} />
      )}
      {isAddSolutionPopupVisible && (
        <AddEditSolution
          title={t("ADD_MANUAL_MATCHING")}
          onClose={closeSolutionCreationPopup}
          onSolutionCreation={onSolutionCreation}
          enquiryService={enquiryService}
          enquirySubCategoryName={enquirySubCategoryName}
          enquirySubCategoryId={enquirySubCategoryId}
          enquiryId={enquiryId}
          countryId={countryId}
        />
      )}
    </SolutionsListContainer>
  );
};

PrepareDataTable.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.array.isRequired,
  siteId: PropTypes.number,
  enquiryId: PropTypes.number,
  centreId: PropTypes.number,
  enquiryStep: PropTypes.number,
  setEnquiryData: PropTypes.func,
  updateRequestRefeshStatus: PropTypes.func,
  onSolutionCreation: PropTypes.func,
  enquiryService: PropTypes.string,
  enquirySubCategoryName: PropTypes.string,
  enquirySubCategoryId: PropTypes.number,
};

PrepareDataTable.defaultProps = {
  centreId: null,
  siteId: null,
  enquiryId: null,
  enquiryStep: null,
  setEnquiryData: null,
  updateRequestRefeshStatus: null,
  onSolutionCreation: null,
  enquiryService: null,
  enquirySubCategoryName: null,
  enquirySubCategoryId: null,
};

export default withTranslation()(PrepareDataTable);
